import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';

import { AnchoredPopupComponent } from '@shared/components/anchored-popup/anchored-popup.component';

import { EntityAutoCompleteService } from '@features/components/entities/entity-auto-complete-dialog/entity-auto-complete.service';

import { MoveToFormComponent } from './move-to-form/move-to-form.component';
import { PlanEditFormsService } from './plan-edit-forms.service';
import { RouteResourcesFormComponent } from './route-resources-form/route-resources-form.component';
import { SetTimeFormComponent } from './set-time-form/set-time-form.component';
import { SwapResourcesFormComponent } from './swap-resources-form/swap-resources-form.component';

/** Renders the open plan edit form, anchored to what it acts on. Hosted once, at the root. */
@Component({
  selector: 'app-plan-edit-form-outlet',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AnchoredPopupComponent,
    SetTimeFormComponent,
    MoveToFormComponent,
    RouteResourcesFormComponent,
    SwapResourcesFormComponent
  ],
  templateUrl: './plan-edit-form-outlet.component.html',
  styles: ``
})
export class PlanEditFormOutletComponent {
  protected readonly forms = inject(PlanEditFormsService);
  private readonly picker = inject(EntityAutoCompleteService);
  private pickerWasOpen = false;

  constructor() {
    // The reference picker renders outside the popup and closes inside its own click handler, so
    // by the time the popup sees that click the picker is gone. Read it before any handler runs.
    const note = () => (this.pickerWasOpen = this.picker.isVisible());
    const document = inject(DOCUMENT);
    document.addEventListener('click', note, true);
    document.addEventListener('keydown', note, true);
    inject(DestroyRef).onDestroy(() => {
      document.removeEventListener('click', note, true);
      document.removeEventListener('keydown', note, true);
    });
  }

  /** A click or Escape that belongs to the reference picker is not an outside click. */
  protected dismiss(): void {
    if (this.pickerWasOpen) return;
    this.forms.close();
  }
}
